import { createFileRoute } from "@tanstack/react-router"
import { GroupTripPlannerPage } from "@/components/pages/GroupTripPlannerPage"
import { defaultMeta } from "@/lib/seo"

// Dedicated landing page for the "group trip planner" / "collaborative trip
// planner" query family — the collaboration head terms live here so
// /ai-trip-planner can stay focused on the AI query family.
export const Route = createFileRoute(`/_public/group-trip-planner`)({
  ssr: true,
  head: () =>
    defaultMeta({
      title: `Group Trip Planner — Plan Trips Together in Real Time`,
      description: `Free group trip planner: one shared itinerary on a live map that your whole crew edits together in real time, with Chic, an AI copilot, drafting the first version. No spreadsheets, no version chaos.`,
      path: `/group-trip-planner`,
    }),
  component: GroupTripPlannerPage,
})
